
import React from 'react';
import helloHandShake from '../../../assets/services-pages/hello.mp4';
import logistic2 from '../../../assets/services-pages/3.png';
import retail from '../../../assets/services-pages/6.png';
import education from '../../../assets/services-pages/8.png';
import finance1 from '../../../assets/services-pages/9.png';
import healthcare from '../../../assets/services-pages/12.png';
import manufacturing1 from '../../../assets/services-pages/11.png';
import { Helmet } from 'react-helmet';
import './soft-dev.css';

function SoftwareDevelopment() {
    return (
        <>
            <Helmet>
                <title>Custom Software Development Services | ERA Automation & Software</title>
                <meta
                    name="description"
                    content="We specialize in custom software development solutions tailored to meet your business needs, from concept to deployment. Enhance your business efficiency with our expert software development services."
                />
                <meta
                    name="keywords"
                    content="Software Development, Custom Software Development, Software Development Company, Software Solutions, ERA Automation, bespoke software development, cloud-based software development, agile software development, ERA Software, ERA Automation and Software"
                />
            </Helmet>

            {/* Hero Section */}
            <div className="relative w-full h-screen">
                <video
                    className="absolute top-0 left-0 w-full h-full object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                >
                    <source src={helloHandShake} type="video/mp4" />
                </video>
                <div className="relative z-10 text-white w-full lg:w-3/5 lg:pl-10 px-6 pt-32 md:pt-44 text-center lg:text-left">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl uppercase leading-snug">
                        You share the same <br />
                        <span className="font-bold lg:text-6xl md:text-5xl sm:text-4xl text-4xl" >vision</span> and <span className="font-bold lg:text-6xl md:text-5xl sm:text-4xl text-4xl">dedication</span> <br />
                        <span className="text-4xl md:text-6xl lg:text-7xl font-italiana">as we do</span>
                    </h1>
                </div>
            </div>

            {/* Software Development Overview */}
            <div className="py-20 px-4 sm:px-8 lg:px-16 text-center lg:h-screen max-h-screen md:h-screen largeScreen">
                <h1 className="uppercase text-4xl sm:text-5xl font-bold pb-8 h1Tag">software development</h1>
                <h3 className="capitalize text-2xl sm:text-3xl py-2 text-gray-700 h3Tag">your vision</h3>
                <h3 className="capitalize text-2xl sm:text-3xl py-2 text-gray-700 h3Tag">our code</h3>
                <h3 className="capitalize text-2xl sm:text-3xl pb-8 text-gray-700 h3Tag">limitless possibilities</h3>
                <div className="max-w-3xl mx-auto py-8">
                    <h2 className="text-2xl sm:text-3xl font-semibold py-4 h2Tag">
                        Empowering Your Business with Tailored Software Solutions
                    </h2>
                    <p className="text-lg sm:text-xl text-justify pTag">
                        At ERA Software, we specialize in creating custom software solutions designed to meet the specific requirements of your business. Whether you're
                        looking to streamline operations, enhance productivity, or tackle complex challenges, our software engineering expertise ensures we deliver
                        solutions that drive success.
                    </p>
                </div>
            </div>

            {/* What We Offer and Commitment Section */}
            <div className="bg-black text-white py-16 px-4 sm:px-8 lg:px-16 lg:h-screen md:h-screen sm:h-full largeScreen">
                <div className="text-center pb-16">
                    <h1 className="capitalize font-semibold text-3xl sm:text-4xl py-4">What We Offer</h1>
                    <ul className="text-lg sm:text-xl list-disc list-inside space-y-4 text-gray-300">
                        <li>Custom Software Development</li>
                        <li>Software Architecture</li>
                        <li>Software Quality Assurance</li>
                        <li>System Integration</li>
                        <li>IT Consulting and Business Analysis</li>
                    </ul>
                </div>
                <div className="text-center mt-12 max-w-3xl mx-auto">
                    <h1 className="capitalize font-semibold text-3xl sm:text-4xl py-4">Our Commitment to Excellence</h1>
                    <p className="text-lg sm:text-xl text-gray-300">
                        ERA Software combines cutting-edge technology with industry best practices to deliver software tailored to your unique needs. From initial
                        planning to final deployment, we focus on:
                    </p>
                    <ul className="list-disc list-inside text-lg sm:text-xl space-y-4 pt-4 text-gray-300">
                        <li>Delivering innovative software products</li>
                        <li>Ensuring top-notch quality assurance</li>
                        <li>Providing continuous support and scalability</li>
                    </ul>
                </div>
            </div>

            {/* Industries We Serve */}
            <div className="py-16 px-4 sm:px-8 lg:px-16 md:h-screen">
                <h1 className="capitalize font-semibold text-3xl sm:text-4xl text-center pb-8">Industries We Serve</h1>
                <p className="text-center text-lg sm:text-xl max-w-3xl mx-auto pb-8">
                    We’ve partnered with businesses across diverse industries to deliver impactful software solutions:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[
                        { title: 'Manufacturing', image: manufacturing1 },
                        { title: 'Retail', image: retail },
                        { title: 'Healthcare', image: healthcare },
                        { title: 'Finance', image: finance1 },
                        { title: 'Logistics', image: logistic2 },
                        { title: 'Education', image: education },
                    ].map((industry) => (
                        <div key={industry.title} className="text-center">
                            <img src={industry.image} alt={`Industry: ${industry.title}`} className="w-60 sm:w-80 mx-auto" />
                            <p className="font-bold text-lg sm:text-xl capitalize py-4">{industry.title}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Final CTA */}
            <div className="py-32 px-4 sm:px-8 lg:px-16 text-center">
                <h1 className="capitalize font-semibold text-3xl sm:text-4xl">Build Software That Works for You</h1>
                <p className="text-lg sm:text-xl pt-4">
                    Whether you need a comprehensive software development service, reliable system integration, or expert IT consulting, ERA Software is here to help.
                </p>
            </div>
        </>
    );
}

export default SoftwareDevelopment;
